import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { UserGlobalContext } from "./contexts/user/userGlobalContext";
import { QuestionsContext } from "./contexts/questions/questionsContext";
import { NavigationProvider } from "./contexts/navigation/NavigationProvider";
import { ConnectionContext } from "./contexts/connection/connectionContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <NavigationProvider>
      <UserGlobalContext>
        <ConnectionContext>
          <QuestionsContext>
            <App />
          </QuestionsContext>
        </ConnectionContext>
      </UserGlobalContext>
    </NavigationProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
